export const TIME_TO_RESEND = 60000;
